// アプリのバージョンチェックと強制リフレッシュ
let versionCheckInterval = null;
let currentVersion = null;

/**
 * サーバーから最新バージョン情報を取得
 */
async function fetchLatestVersion() {
  try {
    // キャッシュを回避するためタイムスタンプをクエリパラメータに追加
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    if (!response.ok) {
      console.warn('バージョン情報の取得に失敗しました');
      return null;
    }
    
    const data = await response.json();
    
    return data;
  } catch (error) {
    console.error('バージョンチェックエラー:', error);
    return null;
  }
}

/**
 * バージョンをチェックし、更新があればリフレッシュ
 */
async function checkVersion(options = {}) {
  const { silent = false } = options;
  
  const latestVersion = await fetchLatestVersion();
  
  if (!latestVersion) {
    return;
  }
  
  // 初回はバージョンを保存するだけ
  if (!currentVersion) {
    currentVersion = latestVersion.version;
    console.log('アプリバージョン:', currentVersion);
    return;
  }
  
  // バージョンが異なる場合は更新が必要
  if (currentVersion !== latestVersion.version) {
    console.log(`新しいバージョンを検出: ${currentVersion} -> ${latestVersion.version}`);
    
    if (!silent) {
      // ユーザーに通知
      const shouldReload = window.confirm(
        '新しいバージョンが利用可能です。\nページを更新して最新版を読み込みますか？'
      );
      
      if (shouldReload) {
        forceReload();
      }
    } else {
      // サイレントモードでは自動的にリロード
      forceReload();
    }
  }
}

/**
 * 強制リフレッシュ（キャッシュをクリア）
 */
function forceReload() {
  // キャッシュストレージをクリア
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }

  // Service Workerがあれば登録解除
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    });
  }
  
  // ローカルストレージの一部情報を保持しながらクリア
  // 認証トークンなどのセッション情報は残す
  const keepKeys = ['auth_token', 'user_info'];
  const storage = {};
  keepKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      storage[key] = localStorage.getItem(key);
    }
  });
  
  localStorage.clear();
  sessionStorage.clear();
  
  keepKeys.forEach(key => {
    if (storage[key]) {
      localStorage.setItem(key, storage[key]);
    }
  });

  // HTTPキャッシュをクリアするため、キャッシュバスティングを加えてリロード
  const timestamp = new Date().getTime();
  window.location.href = window.location.pathname + '?nocache=' + timestamp;
}

/**
 * 定期的なバージョンチェックを開始
 * @param {number} intervalMinutes - チェック間隔（分）
 * @param {object} options - オプション
 */
export function setupVersionCheck(intervalMinutes = 30, options = {}) {
  // 既存のインターバルをクリア
  if (versionCheckInterval) {
    clearVersionCheck();
  }
  
  // 初回チェック
  checkVersion(options);
  
  // 定期チェックを設定
  versionCheckInterval = setInterval(() => {
    checkVersion({ silent: false, ...options });
  }, intervalMinutes * 60 * 1000);
  
  console.log(`バージョンチェックを${intervalMinutes}分ごとに実行します`);
  
  return versionCheckInterval;
}

/**
 * バージョンチェックを停止
 */
export function clearVersionCheck() {
  if (versionCheckInterval) {
    clearInterval(versionCheckInterval);
    versionCheckInterval = null;
    console.log('バージョンチェックを停止しました');
  }
}

/**
 * 手動でバージョンチェックを実行
 */
export async function manualVersionCheck() {
  await checkVersion({ silent: false });
}

/**
 * 強制リフレッシュを実行
 */
export { forceReload };
